/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_SubtitleInputs */

const tr_iletisim_subtitle = /** @type {(inputs: Iletisim_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her başvurumuza yanıt veriyoruz. Aşağıdaki kanallardan doğrudan ekibimize ulaşabilir, KVKK başvurularınızı KEP ve kvkk@emonse.com üzerinden iletebilirsiniz.`)
};

const en_iletisim_subtitle = /** @type {(inputs: Iletisim_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We answer every enquiry. You can reach our team directly through the channels below and submit your KVKK requests via KEP and kvkk@emonse.com.`)
};

const de_iletisim_subtitle = /** @type {(inputs: Iletisim_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir beantworten jede Anfrage. Über die folgenden Kanäle erreichen Sie unser Team direkt; Ihre KVKK-Anträge können Sie über KEP und kvkk@emonse.com einreichen.`)
};

const ru_iletisim_subtitle = /** @type {(inputs: Iletisim_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы отвечаем на каждое обращение. Через указанные ниже каналы вы можете напрямую связаться с нашей командой, а заявления по KVKK направить через KEP и kvkk@emonse.com.`)
};

/**
* | output |
* | --- |
* | "We answer every enquiry. You can reach our team directly through the channels below and submit your KVKK requests via KEP and kvkk@emonse.com." |
*
* @param {Iletisim_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_subtitle = /** @type {((inputs?: Iletisim_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_subtitle(inputs)
	if (locale === "de") return de_iletisim_subtitle(inputs)
	if (locale === "ru") return ru_iletisim_subtitle(inputs)
	return tr_iletisim_subtitle(inputs)
});